<template>
  <div class="d-flex full-width justify-start">
    <div class="d-flex">{{ getTitle(cell) }}</div>
    <div class="d-flex ml-auto">
      <FZSelector @change="setVehicle" context="unfalldesk">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="px-4" rounded outlined v-on="on" v-bind="attrs">{{ getBtnText() }}</v-btn>
        </template>
      </FZSelector>
    </div>
  </div>
</template>
<script>
import FZSelector from './FZSelector.vue';
import { getTitle } from './wb-common';
import common from '@/mixins/common';

export default {
  components: { FZSelector },
  mixins: [common],
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data() {
    return {
      getTitle,
    };
  },
  computed: {
    input() {
      return this.$store.state[this.namespace].formInput;
    },
    cellKey() {
      return this.cell.key + this.mIndex;
    },
    instance(){
      return this.$route.params.instance
    }
  },
  methods: {
    setVehicle(vehicle) {
      const fz=vehicle.fzName;
      const fzTyp=vehicle.fzTyp;
      this.$set(this.input, this.cellKey, {fz, fzTyp, id:vehicle.id});
      this.$router.push({path: this.$route.path,query:{fzId:vehicle.id}});
    },
    getBtnText() {
      const fz = this.input[this.cellKey]?.fz;
      if (fz === undefined) {
        return this.$t('ud-protokoll-config.eigenes_fahrzeug.fahrzeug.title');
      } else {
        return fz;
      }
    },
  },
};
</script>
<style scoped>
.selector {
  justify-self: flex-end;
}
</style>
